<script>
    import { removeDuplicates } from "@/utils";

    export default {
        name: "ProductColorsList",
        props: {
            currentOffer: Object,
            offers: Array,
            isHiddenSingle: {
                type: Boolean,
                default: true,
            },
            isDecorative: Boolean,
        },
        data() {
            return {
                currentColor: this.currentOffer.color?.id,
                // проверка сброса цвета при переходах между товарами
            };
        },
        computed: {
            colorsList() {
                const colors = this.offers
                    .filter((offer) => offer.color)
                    .map((offer) => offer.color);
                return removeDuplicates(colors);
            },
        },
        methods: {
            onSelectColor(color) {
                this.currentColor = color.id;
                this.$emit("select-color", color);
            },
        },
    };
</script>

<template>
    <div
        class="product-colors-list"
        :class="{
            'is-decorative': isDecorative,
            'is-single': colorsList.length < 2 && isHiddenSingle,
        }"
    >
        <button
            class="product-colors-list__item outline"
            :class="{ 'is-active': currentColor === color.id && !isDecorative }"
            v-for="color in colorsList"
            :key="color.id"
            :disabled="isDecorative"
            :tabindex="currentColor === color.id && !isDecorative ? -1 : 0"
            @click="onSelectColor(color)"
        >
            <span
                class="product-colors-list__item-circle"
                :class="{ 'has-border': color.code === 'ffffff' }"
                :style="{ backgroundColor: `#${color.code}` }"
                role="img"
                :alt="color.name + ' цвет'"
            ></span>
        </button>
    </div>
</template>

<style lang="scss">
    .product-colors-list {
        display: flex;
        flex-wrap: wrap;
        &.is-decorative {
            pointer-events: none;
        }
        &.is-single {
            visibility: hidden;
        }
    }

    .product-colors-list__item {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        @include box(var(--color-item-circle-out));
        border-radius: 50%;
        transition: border 0.2s ease-in;
        cursor: pointer;
        border: var(--color-item-border);
        &.is-active {
            pointer-events: none;
            border-color: var(--color-item-fill);
        }
        &:not(:last-child) {
            margin-right: var(--color-item-space);
        }
        &:hover {
            .product-colors-list__item-circle {
                transform: scale(1.05);
            }
        }
    }

    .product-colors-list__item-circle {
        @include box(var(--color-item-circle-in));
        border-radius: 50%;
        transition: 0.2s ease all;
        &.has-border {
            border: 1px solid #bdbdbd;
        }
    }
</style>
